var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroBlob2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 372,
    height: 325.771,
    viewBox: "0 0 372 325.771",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Watercolor blob",
    opacity: 0.8,
    filter: "url(#filter0_f_0_54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M192.414 28.8C250.138 14.4 301.448 57.6 320.69 115.2C339.931 172.8 333.517 237.6 288.621 273.6C243.724 309.6 166.759 316.8 115.448 288C64.1379 259.2 38.4828 201.6 51.3103 144C64.1379 86.4 134.69 43.2 192.414 28.8Z",
    fill: "url(#paint0_linear_0_54)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_0_54",
    x: -20,
    y: -20,
    width: 412,
    height: 364,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_0_54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_54",
    x1: 48.0414,
    y1: 26.0091,
    x2: 247.859,
    y2: 228.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FA8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7C8FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBlob2);
export default __webpack_public_path__ + "static/media/hero-blob-2.eea4edc0faee972155920543d1631337.svg";
export { ForwardRef as ReactComponent };